import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { start_logout } from 'src/app/store/action/logout.action'
import { AppState } from 'src/app/store/state/app.state'
import { environment } from 'src/environments/environment'
import { getUserFromState } from '../../../store/selector/initialize.selector'
import { Observable } from 'rxjs'
import { UserAPIModel } from '../../../models/api.model'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  readonly DASHBOARD = `/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly SETTINGS = `/${GlobalConstants.ROUTING.SETTINGS}`
  readonly ADMIN_PORTAL_LINK = environment.sopAdminPortalLink
  readonly PROFILE = `/${GlobalConstants.ROUTING.PROFILE}`

  user$: Observable<UserAPIModel>

  constructor(private appState: Store<AppState>) {}

  ngOnInit(): void {
    this.user$ = this.appState.select(getUserFromState)
  }

  logout() {
    this.appState.dispatch(start_logout({}))
  }
}
